export default __webpack_public_path__ + "static/media/16.817e9b39.png";